import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { TextFieldLight } from "../../../common/components/styled/styled";
import { dateTimeFormat } from "../../../common/helpers/formatDateTime";

interface Props {
  isNewOrder?: boolean;
  value: {
    title: string;
    createdAt: EpochTimeStamp;
    createdAtWithTimestamp?: EpochTimeStamp;
    orderer: string;
    customerOrgName: string;
  };
}

// FIXME order additional info naming
export const BasicInfoOrderFields = ({ isNewOrder, value }: Props) => {
  const { t } = useTranslation("order");
  const style = isNewOrder ? { display: "none" } : { display: "contents" };
  const formattedDate = value.createdAtWithTimestamp
    ? format(new Date(value.createdAtWithTimestamp), dateTimeFormat)
    : format(
        new Date(0).setUTCSeconds(value.createdAt!! / 1000),
        dateTimeFormat,
      );
  return (
    <Box sx={style}>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ paddingBottom: 1 }}
      >
        <Typography variant="secondary">{t("orderName")}</Typography>
      </Grid>
      <Grid item xs={9} sx={{ paddingLeft: 2, paddingBottom: 1 }}>
        <TextFieldLight
          sx={{ width: "360px" }}
          value={value.title}
          size="small"
          disabled
        />
      </Grid>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ paddingBottom: 1 }}
      >
        <Typography variant="secondary">{t("orderedDate")}</Typography>
      </Grid>
      <Grid item xs={9} sx={{ paddingLeft: 2, paddingBottom: 1 }}>
        <TextFieldLight
          sx={{ width: "360px" }}
          value={formattedDate}
          size="small"
          disabled
        />
      </Grid>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ paddingBottom: 1 }}
      >
        <Typography variant="secondary">{t("orderer")}</Typography>
      </Grid>
      <Grid item xs={9} sx={{ paddingLeft: 2, paddingBottom: 1 }}>
        <TextFieldLight
          sx={{ width: "360px" }}
          value={value.orderer}
          size="small"
          disabled
        />
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("customer")}</Typography>
      </Grid>
      <Grid item xs={9} sx={{ paddingLeft: 2 }}>
        <TextFieldLight
          sx={{ width: "360px" }}
          value={value.customerOrgName}
          size="small"
          disabled
        />
      </Grid>
    </Box>
  );
};
